var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHatchBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "373px",
    height: "602px",
    viewBox: "0 0 373 602",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HatchBot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "52.0789214%",
    x2: "100%",
    y2: "52.0789214%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#868585",
    offset: "12.85226%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D8D8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "33.09574%",
    cy: "25.100425%",
    fx: "33.09574%",
    fy: "25.100425%",
    r: "80.6958803%",
    gradientTransform: "translate(0.330957,0.251004),scale(1.000000,0.588957),rotate(-64.465689),scale(1.000000,0.604655),translate(-0.330957,-0.251004)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "60.6515443%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0",
    offset: "77.1039942%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898181",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898181",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.4689616%",
    y1: "86.2570358%",
    x2: "-17.5356343%",
    y2: "11.9550286%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B8845",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46C85E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "32.5671813%",
    cy: "48.3633262%",
    fx: "32.5671813%",
    fy: "48.3633262%",
    r: "119.304591%",
    gradientTransform: "translate(0.325672,0.483633),scale(1.000000,0.468586),rotate(-78.953787),scale(1.000000,0.572857),translate(-0.325672,-0.483633)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF",
    offset: "60.6515443%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0",
    offset: "77.1039942%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898181",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898181",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HatchBot",
    transform: "translate(-137.000000, -66.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rightLegAndFoot",
    transform: "translate(264.000000, 308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leftFoot",
    transform: "translate(123.440386, 213.440386) scale(-1, 1) rotate(-312.000000) translate(-123.440386, -213.440386) translate(48.440386, 120.940386)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_1_",
    fill: "#0B8845",
    points: "60 180.5 128 159 75 110 5 133.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2_1_",
    fill: "#0B8845",
    points: "129.455927 157.719228 150 50.5 96 1.5 76.5908041 108.190248"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#46C85E",
    points: "4.31088755 132.902732 75.3133163 108.811729 96 1.5 26.5 24.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76,1 L76,169.840895 C79.2458052,179.634352 90.4957176,184.60791 110,184.60791 C129.504282,184.60791 140.754195,179.634352 144,169.840895 L144,1 L76,1 Z",
    id: "leftLeg",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leftLegAndFoot",
    transform: "translate(158.000000, 368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leftFoot",
    transform: "translate(119.440386, 213.440386) scale(-1, 1) rotate(-312.000000) translate(-119.440386, -213.440386) translate(44.440386, 120.940386)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_1_",
    fill: "#0B8845",
    points: "60 180.5 128 159 75 110 5 133.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2_1_",
    fill: "#0B8845",
    points: "129.455927 157.719228 150 50.5 96 1.5 76.5908041 108.190248"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#46C85E",
    points: "4.31088755 132.902732 75.3133163 108.811729 96 1.5 26.5 24.5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.5,1.5 L72.5,169.759569 C75.6955568,179.248908 86.7380825,184.10791 106,184.10791 C125.261918,184.10791 136.304443,179.248908 139.5,169.759569 L139.5,1.5 L72.5,1.5 Z",
    id: "leftLeg",
    stroke: "#4A4A4A",
    strokeWidth: 3,
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M413.416261,293.56749 C427.721409,285.466954 438.526345,278.6681 445.831067,273.170928 C453.13579,267.673756 456.363663,257.333817 455.514687,242.151109 L455.951289,217.318144 C455.662292,206.688534 458.231395,197.772781 463.658599,190.570884 C467.276736,185.769619 472.647372,179.376517 479.770507,171.391578 C487.846185,163.649098 486.727083,149.491596 477.270923,139.769911 C467.814764,130.048226 451.499233,127.30944 443.423555,135.051919 C431.377415,144.460498 423.485177,151.097451 419.74684,154.962779 C411.335582,163.659768 404.387386,168.845481 404.387386,201.18503 C404.387386,222.744729 404.387386,232.599816 404.387386,230.75029 C404.634289,234.891713 403.435406,238.69046 400.790736,242.146529 C398.146067,245.602599 394.270842,248.742434 389.16506,251.566034 L413.416261,293.56749 Z",
    id: "Oval-Copy",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "url(#radialGradient-2)",
    transform: "translate(437.165060, 212.067490) rotate(28.000000) translate(-437.165060, -212.067490) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo_icon",
    transform: "translate(312.576859, 316.279110) rotate(-330.000000) translate(-312.576859, -316.279110) translate(87.576859, 81.779110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "megaCube",
    transform: "translate(-0.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#0B8845",
    transform: "translate(177.086952, 307.588522) rotate(18.000000) translate(-177.086952, -307.588522) ",
    points: "161.086952 396.088522 331.086952 341.088522 198.586952 219.088522 23.086952 278.088522"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2",
    fill: "url(#linearGradient-3)",
    transform: "translate(315.783531, 227.792633) rotate(18.000000) translate(-315.783531, -227.792633) ",
    points: "362.533531 380.042633 402.533531 198.042633 268.033531 75.5426334 229.033531 258.542633"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Combined-Shape",
    fill: "#46C85E",
    transform: "translate(178.733843, 149.615699) rotate(18.000000) translate(-178.733843, -149.615699) ",
    points: "91.9838435 178.865699 168.983843 152.865699 188.483843 60.8656993 285.483843 28.8656993 246.483843 212.365699 71.9838435 270.365699"
  })), /*#__PURE__*/React.createElement("g", {
    id: "miniCube",
    transform: "translate(118.855358, 91.248883) rotate(18.000000) translate(-118.855358, -91.248883) translate(48.855358, 18.748883)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_1_",
    fill: "#0B8845",
    points: "56 144.5 124 123 71 74 1 97.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2_1_",
    fill: "#0B8845",
    points: "124 123 140 50.5 86 1.5 70.5 74.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#46C85E",
    points: "1 97.5 70.5 74.5 86 1.5 16.5 24.5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "white-lines",
    transform: "translate(139.000000, 243.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.5,290.5 L198.5,252.5",
    id: "Line-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5,290.5 L325.5,253.5",
    id: "Line-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5,290.5 L261.5,361.776367",
    id: "Line-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.5,349.5 L213.735352,314.166016",
    id: "Line-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.187988,349.080078 L151.875977,422.658203",
    id: "Line-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5,293.5 L150.5,350.5",
    id: "Line-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,92.5 L159.5,273.5",
    id: "Line-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5,4.5 L159.302246,92.7045898",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.466309,92.8334961 L322.063477,0.458007812",
    id: "Line-2"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#000000",
    strokeWidth: 2,
    points: "228.810547 518.34375 195.158203 536.517578 195.158203 608.595703 290.269531 666.021484 353.429688 629.324219 353.429688 556.570312 298.350586 522.523438"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-6",
    stroke: "#000000",
    strokeWidth: 2,
    points: "353.359375 578.191406 400.850586 605.71582 462.904297 569.123047 464.645508 496.71875 407.585938 462.25293"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.5,526.083008 L305.5,513.5",
    id: "Line-8",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-5",
    stroke: "#000000",
    strokeWidth: 2,
    points: "220.734375 200.094727 138.586914 247.207031 142.566406 427.332031 298.234375 517.339844 459.828125 424.666016 461.52832 242.870117 372.522461 192.892578"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.203892,317.290991 C220.321733,306.408832 204.224627,304.862472 195.25,313.837099 C182.764648,322.337262 172.768311,330.373965 165.260986,337.947207 C157.753662,345.520449 154,363.807396 154,392.808047 L154,477.179385 C154,485.463656 167.431458,492.587099 184,492.587099 C200.568542,492.587099 214,486.532381 214,478.24811 L214,393.874941 C214,382.065045 215.153158,374.30707 217.459473,370.601015 C219.765788,366.894961 225.498558,361.109583 234.657784,353.244883 C243.632411,344.270256 242.086051,328.17315 231.203892,317.290991 Z",
    id: "arm",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "url(#radialGradient-4)",
    transform: "translate(197.247441, 400.293550) rotate(-360.000000) translate(-197.247441, -400.293550) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-7",
    stroke: "#000000",
    strokeWidth: 2,
    points: "229.5 177.425781 227.551758 105.298828 291.949219 67.9414062 355.769531 103.819336 355.769531 175.762695 291.660645 213.024414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatchBot);
export default __webpack_public_path__ + "static/media/HatchBot.484218bc6ccc40b10fcaedaa27b9d2fc.svg";
export { ForwardRef as ReactComponent };